<template>
  <div>

    <body data-anchor="pagetop" class="home page-template-default page page-id-314 wp-embed-responsive st-Grid_Container" style="overflow-y: unset;background-color: #f5f7f7;">
      <navbar follow="st-Header" imgSrc="../../../../static/img/landing/logo_black.png" searchImgSrc="../../../../static/img/landing/search_black.png"></navbar>
      <div class="st-MainContainer">
        <main class="st-MainContents" style="padding-top:120px;">
          <header class="news-PageTitle mb-5">
            <div class="news-PageTitle_Inner">
              <h1 class="sw-Section_Header appear" data-appear>
                <span class="sw-Section_Header-en"><b>Contact Us</b></span>
                <span class="sw-Section_Header-ja"><b>お問い合わせ</b></span>
                <br>
              </h1>
              <h2 style="font-weight: unset;">弊社に興味をお持ちいただきありがとうございます。
                <br>
                お問い合わせいただきました内容は、弊社の掲げる個人情報保護方針に沿って管理し、お客様の同意なく第三者に開示・提供することはございません。
                <br>
                詳細につきましては、当サイトの「プライバシーポリシー」をご参照ください。
                <br>
              </h2>
            </div>
          </header>
          <section class="policy-Block p-0">
            <div class="col-12" style="border: 1px solid #1c1c1c;">
              <div style="margin: 50px 20px 10px 20px;padding: 30px 20px;border: 2px solid #1c1c1c;">
                <div class="m-0" style="justify-content: center;display: flex;align-items: center;">
                  <div class="" style="width:100%;border: 2px solid #1c1c1c;padding: 5px 15px;font-size: 1.8em;background: #56d0bb;color: #fff;margin: -59px 0px 0px 0px;">お問い合わせ</div>
                </div>
                <el-form :model="emailForm" :rules="rules" ref="emailForm" label-width="0px" class="demo-emailForm" method="post" action="">
                  <div class="col-12 pt-5 m-0">
                    <div class="col-12 m-0">
                      <label for="name" class="loginLabelText">
                        <div class="row">
                          <h2 class="mb-0">お名前</h2>
                          <h1 class="mb-0" style="margin-top: 3px;margin-left:10px">*</h1>
                        </div>
                      </label>
                    </div>
                    <div class="col-12 pl-0 pr-0">
                      <el-form-item prop="name" class="col-12 p-0">
                        <el-input type="text" style="" class="m-0" auto-complete="on" id="name" name="name" v-model="emailForm.name" placeholder="">
                        </el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="col-12 pt-4 mb-6">
                    <div class="col-12 m-0">
                      <label for="email" class="loginLabelText">
                        <div class="row">
                          <h2 class="mb-0">メールアドレス</h2>
                          <h1 class="mb-0" style="margin-top: 3px;margin-left:10px">*</h1>
                        </div>
                      </label>
                    </div>
                    <div class="col-12 pl-0 pr-0">
                      <el-form-item prop="email" class="col-12 p-0">
                        <el-input v-model="emailForm.email" class="m-0" auto-complete="on" id="email" name="email" placeholder=""></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="col-12 pt-0">
                    <div class="col-12 m-0 mb-3">
                      <label for="message" class="loginLabelText">
                        <div class="row">
                          <h2 class="mb-0">本文</h2>
                        </div>
                      </label>
                    </div>
                    <div class="col-12 pl-0 pr-0">
                      <el-form-item class="col-12 p-0">
                        <el-input type="textarea" :rows="12" id="message" name="message" v-model="emailForm.message"></el-input>
                      </el-form-item>
                    </div>
                  </div>
                </el-form>
              </div>
              <el-button style="margin: 10px 20px 30px 20px;" @click="submitEmailForm('emailForm')" type="primary">送信</el-button>
            </div>
          </section>
        </main>
        <div class="st-Breadcrumbs">
          <ul class="st-BreadcrumbsList" itemscope="itemscope" itemtype="">
            <li class="st-BreadcrumbsList_Item" itemprop="itemListElement" itemscope="itemscope" itemtype="">
              <a class="st-BreadcrumbsList_Item-link" href="/" itemprop="item">ホーム</a>
              <meta itemprop="position" content="1">
            </li>
            <li class="st-BreadcrumbsList_Item" itemprop="itemListElement" itemscope="itemscope" itemtype="">
              <p itemprop="item" aria-current="page" style="margin-bottom: 0rem;"><span itemprop="name">お問い合わせ</span></p>
              <meta itemprop="position" content="3">
            </li>
          </ul>
        </div>
      </div>
      <copyright></copyright>
    </body>
  </div>
</template>
<style />
<script type="text/javascript">
import copyright from './../copyright'
import navbar from './../navbar'

export default {
  components: { copyright, navbar },
  data: function () {
    return {
      emailForm: {
        name: '',
        email: '',
        message: ''
      },
      rules: {
        name: [
          { required: true, message: 'This field is required.', trigger: ['change'] },
          { min: 1, max: 128, message: 'Please enter no more than 128 characters.', trigger: ['change'] }
        ],
        email: [
          { required: true, message: 'Please input the email address.', trigger: 'change' },
          { type: 'email', message: 'Please input the correct email address.', trigger: ['change'] }
        ]
      }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    submitEmailForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // let a = document.createElement('a')
          // .setAttribute('href', `mailto:koyama@nicecera.jp?subject=${this.emailForm.name}&body=${this.emailForm.message}`)
          // a.setAttribute('target', '_blank')
          // a.click()
          console.log($('.demo-emailForm').serialize())
          $.ajax({
            url: 'https://formspree.io/f/moqyeeno',
            type: 'post',
            async: true,
            data: {
              name: this.emailForm.name,
              email: this.emailForm.email,
              message: this.emailForm.message
            },
            dataType: 'json',
            success: (response) => {
              alert('送信完了')
            }
          })
        } else {
          return false
        }
      })
    },
    init() {
      $(document).scroll(() => {
        let scroH = $(document).scrollTop()
        let viewW = $(window).width()
        console.log(scroH)
        if (scroH > 50) {
          $('.st-Header').addClass('is-follow')
          $('.st-Footer_Pagetop').addClass('is-follow')
        } else {
          $('.st-Header').removeClass('is-follow')
          $('.st-Footer_Pagetop').removeClass('is-follow')
        }

        if (viewW > 769) {
          if (scroH >= 200) {
            $('.sw-Section_Header').eq(0).removeClass('appear')
          } else {
            $('.sw-Section_Header').eq(0).addClass('appear')
          }
        } else {
        }

        // appear
      })
    }
  }
}
</script>
<style scoped>
.el-button--primary:focus, .el-button--primary:hover {
    background: #56d0bb;
    border-color: #56d0bb;
    color: #333;
}
.el-button--primary{
    background: #1c1c1c;
    border: #55d1b7;
    color: #fff;
    color: #fff;
}
.demo-emailForm>>>.el-input__inner {
    background: #f2f2f2;
    border: 1px solid #55d1b7;
}
.demo-emailForm>>>.el-textarea__inner{
    background: #f2f2f2;
    border: 1px solid #55d1b7;
}
  .home>>>.st-Nav_List-en {
    color: #222;
  }

  .home>>> .st-Nav_List-ja {
    color: #222;
  }
  .home>>> .st-Header {
    background-color: #fff;
    border-bottom: 1px solid #ddd;
    transition: height .2s ease-in-out;
  }

  a {
    border-bottom-style: none;
  }

  .sw-ButtonRound a {
    padding: 18px 50px;
    min-width: 160px;
    background-color: #c7000b;
  }

  .sw-ButtonRound a span {
    margin-left: -25px
  }

  .sw-ButtonRound a span,
  .sw-ButtonRound a i {
    background-color: #c7000b;
    color: #FFFFFF;
  }

  .news-Narrow>>>.el-input__inner {
    border-radius: 100px;
    width: 120px;
    border-color: #04192A;
  }

  .is-active {
    background-color: #04192A !important;
  }

  .top-Product_Image-inner img {
    width: 100%
  }
    .home>>>.contactus font {
    color: #c7000b
  }

  .home>>>.contactus:after {
    transform: scaleX(1) !important;
  }

  .swiper-slide-news {
    width: 360px !important;
    margin-right: 60px !important;
    margin-left: 36px !important;
  }

  .news-Narrow_Cate li {
    border-radius: 100px;
  }

  .news-Narrow_Cate li a {
    transition: none;
    border-radius: 100px;
  }

  @media (hover: hover) {
    .news-Narrow_Cate li a:hover {
      border-radius: 100px;
      transition: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/contactus/contactus.vue